import { Box } from "@mui/material";
import {
  type ComponentProps,
  type ComponentType,
  type ReactNode,
  cloneElement,
  createElement,
  useEffect,
  useState,
} from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
type TDetectOverflowProps<Component extends ComponentType<any>> = ComponentProps<Component> & {
  component: Component;
  childAsContainer?: boolean;
  children: ReactNode;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const DetectOverflow = <Component extends ComponentType<any>>({
  component = Box,
  childAsContainer = false,
  children,
  ...props
}: TDetectOverflowProps<Component>) => {
  const [container, setContainer] = useState<HTMLElement>();
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    if (container) {
      const onSizeChange = () => {
        if (container.clientWidth < container.scrollWidth || container.clientHeight < container.scrollHeight) {
          setOverflowing(true);
        } else {
          setOverflowing(false);
        }
      };
      const observer = new ResizeObserver(onSizeChange);
      observer.observe(container);
      return () => {
        observer.unobserve(container);
      };
    }
  }, [container]);

  if (childAsContainer) {
    return cloneElement(children, { ref: setContainer, isOverflowing: overflowing });
  }
  return createElement(
    component || Box,
    { ref: setContainer, ...props },
    cloneElement(children, { isOverflowing: overflowing })
  );
};

export { TooltipOverflow } from "./TooltipOverflow";
export { TypoTooltip } from "./TypoTooltip";
